import React, { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Route, Routes, useLocation } from 'react-router-dom';
import LoginPage from '../pages/login';
import ForgotPassword from '../pages/forgot-password';
import HomePage from '../pages/home';
import AuthBg from '../components/not-auth/AuthBg';
import UsersPage from '../pages/user';
import SupportPage from '../pages/support';
import AccountPage from '../pages/account';
import SettingsPage from '../pages/settings';
import CMSInfoPage from '../pages/cms-info';
import RolesPage from '../pages/roles';
import ResetPassword from '../pages/reset-password';
import SeoPage from '../pages/seo';
import BulletinsPage from '../pages/bulletins';
import ContentPage from '../pages/content';
import LogPage from '../pages/log';
import FormPage from '../pages/form';
import LanguagePage from '../pages/language';
import FormsPage from '../pages/form/forms';
import FormElementsPage from '../pages/form/form-elements';
import MenuGroupPage from '../pages/menu';
import MenusPage from '../pages/menu/menus';
import SliderGroupPage from '../pages/slider';
import SlidersPage from '../pages/slider/sliders';
import SliderContentPage from '../pages/slider/sliders/sliderContent';
import AboutPage from '../pages/about';
import NewsPage from '../pages/news';
import ContactPage from '../pages/contact';
import DocumentPage from '../pages/document';
import AboutDesignPage from '../pages/about/AboutDesign';
import Page from '../pages/page';
import PageShowcaseDesign from '../pages/page/pageShowcase/PageShowcaseDesign';
import PageShowcase from '../pages/page/pageShowcase';
import PageShowcaseItem from '../pages/page/pageShowcase/pageShowcaseItem';
import SocialMediaPage from '../pages/social-media';
import PageSave from '../pages/page/save';

const AnimatedRoutes = () => {
    const location = useLocation();
    const [load, setLoad] = useState(false)
    const [isAuth, setIsAuth] = useState(false)

    useEffect(() => {
        var auth = localStorage.getItem("auth")
        if (auth !== null) {
            auth = JSON.parse(auth)
            if (auth.accessToken) setIsAuth(true)
            else setIsAuth(false)
        }
        setTimeout(() => {
            setLoad(true)
        }, 500)
    }, [])

    return (
        <AnimatePresence>
            {load ? <Routes key={location.pathname} location={location}>
                <Route path='/' element={isAuth ? <HomePage /> : <LoginPage />} />
                <Route path='/about' element={<AboutPage />} />
                <Route path='/about-design/:id' element={<AboutDesignPage />} />
                <Route path='/account' element={isAuth ? <AccountPage /> : <LoginPage />} />
                <Route path='/bulletins' element={isAuth ? <BulletinsPage /> : <LoginPage />} />
                <Route path='/contact' element={isAuth ? <ContactPage /> : <LoginPage />} />
                <Route path='/content' element={isAuth ? <ContentPage /> : <LoginPage />} />
                <Route path='/cms-info' element={isAuth ? <CMSInfoPage /> : <LoginPage />} />
                <Route path='/document' element={isAuth ? <DocumentPage /> : <LoginPage />} />
                <Route path='/forgot-password' element={isAuth ? <HomePage /> : <ForgotPassword />} />
                <Route path='/form' element={isAuth ? <FormPage /> : <LoginPage />} />
                <Route path='/forms/:id' element={isAuth ? <FormsPage /> : <LoginPage />} />
                <Route path='/form-elements/:id' element={isAuth ? <FormElementsPage /> : <LoginPage />} />
                <Route path='/language' element={isAuth ? <LanguagePage /> : <LoginPage />} />
                <Route path='/login' element={isAuth ? <HomePage /> : <LoginPage />} />
                <Route path='/log' element={isAuth ? <LogPage /> : <LoginPage />} />
                <Route path='/menu-groups' element={isAuth ? <MenuGroupPage /> : <LoginPage />} />
                <Route path='/menu/:id' element={isAuth ? <MenusPage /> : <LoginPage />} />
                <Route path='/news' element={isAuth ? <NewsPage /> : <LoginPage />} />
                <Route path='/page' element={isAuth ? <Page /> : <LoginPage />} />
                <Route path='/page-save' element={isAuth ? <PageSave /> : <LoginPage />} />
                <Route path='/page-save/:slug' element={isAuth ? <PageSave /> : <LoginPage />} />
                <Route path='/page-showcase/:id' element={isAuth ? <PageShowcase /> : <LoginPage />} />
                <Route path='/page-showcase-item/:id' element={isAuth ? <PageShowcaseItem /> : <LoginPage />} />
                <Route path='/page-design/:id' element={isAuth ? <PageShowcaseDesign /> : <LoginPage />} />
                <Route path='/reset-password' element={<ResetPassword />} />
                <Route path='/roles' element={isAuth ? <RolesPage /> : <LoginPage />} />
                <Route path='/seo' element={isAuth ? <SeoPage /> : <LoginPage />} />
                <Route path='/settings' element={isAuth ? <SettingsPage /> : <LoginPage />} />
                <Route path='/slider-groups' element={isAuth ? <SliderGroupPage /> : <LoginPage />} />
                <Route path='/slider/:id' element={isAuth ? <SlidersPage /> : <LoginPage />} />
                <Route path='/slider-content/:id' element={isAuth ? <SliderContentPage /> : <LoginPage />} />
                <Route path='/social-media' element={isAuth ? <SocialMediaPage /> : <LoginPage />} />
                <Route path='/support' element={isAuth ? <SupportPage /> : <LoginPage />} />
                <Route path='/users' element={isAuth ? <UsersPage /> : <LoginPage />} />
                <Route path='/*' element={<HomePage />} />
            </Routes> : <AuthBg />}
        </AnimatePresence>
    );
};

export default AnimatedRoutes;
